import { useQuery } from "@tanstack/react-query";
import React, { useState } from "react";
import { postAxios } from "../Services/commonService";
import { API_POST_SCRIPTWISEPOSITIONHISTORY } from "../utils/api/ApiConstant";
import { Button, DataTable } from "../Components";
import CommonModal from "./CommonModal";
import { head } from "lodash";
import UserWiseScriptPositionHistory from "./UserWiseScriptPositionHistory";

const ServerwiseScriptPositionHistory = ({
  rowData,
  payloadData,
  handleShowHide,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(200);
  const [isShow, setIsShow] = useState({
    isOpen: false,
    rowData: null,
    name: "",
    modalTitle: "",
    modalContent: null,
    apiFlag: false,
  });
  const { isLoading, data: userWisePosition } = useQuery({
    queryKey: ["userWisePosition", rowData?.ServerName],
    queryFn: async () => {
      const param = {
        server: payloadData?.server,
        ScriptToken: rowData?.ScriptToken,
        showIndividually: true,
        PositionDate: payloadData.PositionDate,
      };

      const res = await postAxios({
        url: API_POST_SCRIPTWISEPOSITIONHISTORY,
        payload: param,
      });

      return res;
    },
  });

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleRecordsperPage = (value) => {
    setRecordsPerPage(value);
  };

  const handleClick = (row) => {
    setIsShow((prev) => ({
      ...prev,
      isOpen: true,
      rowData: row.original,
      name: "UserWiseScriptPositionHistory",
      modalTitle: "User Wise Script Position History",
      modalContent: UserWiseScriptPositionHistory,
    }));
  };

  const columns = [
    {
      header: "Userwise",
      cell: ({ row }) => {
        return (
          <Button className={"btn-primary"} onClick={() => handleClick(row)}>
            View
          </Button>
        );
      },
    },
    {
      accessorKey: "PositionDate",
      header: "Position Date",
      cell: ({ getValue }) => {
        const rawDate = getValue();
        const date = new Date(rawDate);

        const options = {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
          timeZone: "Asia/Kolkata", // force IST
        };

        return <div>{date.toLocaleString("en-IN", options)}</div>;
      },
    },
    {
      accessorKey: "ServerName",
      header: "Server Name",
    },
    {
      accessorKey: "ExchangeName",
      header: "Exchange",
      cell: ({ row, getValue }) => {
        return <div style={{ cursor: "pointer" }}>{getValue()}</div>;
      },
    },
    {
      accessorKey: "Script",
      header: "Script",
      cell: ({ row, getValue }) => {
        return <div style={{ cursor: "pointer" }}>{getValue()}</div>;
      },
    },
    {
      accessorKey: "ExpiryDateText",
      header: "Exp. Date",
      cell: ({ row, getValue }) => {
        return <div style={{ cursor: "pointer" }}>{getValue()}</div>;
      },
    },
    {
      accessorKey: "Position",
      header: "Position",
      cell: ({ row, getValue }) => {
        return (
          <div
            style={{
              cursor: "pointer",
              color: getValue() === "BUY" ? "green" : "red",
            }}
          >
            {getValue()}
          </div>
        );
      },
    },
    {
      accessorKey: "OpenQuantity",
      header: "Open Qty",
      cell: ({ row, getValue }) => {
        return (
          <div
            className="text-end"
            style={{
              cursor: "pointer",
              color: Number(getValue()) > 0 ? "green" : "red",
            }}
          >
            {getValue()}
          </div>
        );
      },
    },
    {
      accessorKey: "BuyQty",
      header: "Buy Qty",
      cell: ({ row, getValue }) => {
        const value = getValue();
        return <div className="text-end">{value}</div>;
      },
    },
    {
      accessorKey: "SellQty",
      header: "Sell Qty",
      cell: ({ getValue, row }) => {
        const value = getValue();
        return <div className="text-end">{value}</div>;
      },
    },
    {
      accessorKey: "OpenAvgRate",
      header: "Avg Rate",
      cell: ({ getValue, row }) => {
        const value = getValue();
        return <div className="text-end">{value}</div>;
      },
    },
    {
      accessorKey: "CurrentMapPrice",
      header: "CMP",
      cell: ({ row, getValue }) => {
        return (
          <div className="text-end" style={{ cursor: "pointer" }}>
            {getValue()}
          </div>
        );
      },
    },
    {
      accessorKey: "CurrentMapProfitLoss",
      header: "CM P&L",
      cell: ({ row, getValue }) => {
        return (
          <div className="text-end" style={{ cursor: "pointer" }}>
            {getValue()}
          </div>
        );
      },
    },
  ];

  const fetchData = () => {
    if (!userWisePosition) return { data: [], pages: 0 };

    const startIndex = (currentPage - 1) * recordsPerPage;
    const endIndex = startIndex + recordsPerPage;

    return {
      data: userWisePosition.slice(startIndex, endIndex),
      pages: Math.ceil(userWisePosition.length / recordsPerPage),
    };
  };

  return (
    <>
      <DataTable
        columns={columns}
        // fetchData={fetchData}
        data={fetchData().data}
        pages={fetchData().pages}
        isLoading={isLoading}
        currentPage={currentPage}
        onPageChange={handlePageChange}
        onRecordsPerPageChange={handleRecordsperPage}
        recordsPerPage={recordsPerPage}
        isSearchable={false}
        isPagination={true}
        isPageSize={true}
        isIndexing={true}
      />

      {isShow.isOpen && (
        <CommonModal
          isShow={isShow.isOpen}
          handleShowHide={() =>
            setIsShow((prev) => ({
              ...prev,
              isOpen: false,
              rowData: {},
              name: "",
            }))
          }
          modalTitle={isShow.modalTitle}
        >
          {isShow.modalContent &&
            React.createElement(isShow.modalContent, {
              handleShowHide: () =>
                setIsShow((prev) => ({
                  ...prev,
                  isOpen: false,
                  rowData: {},
                  name: "",
                  modalTitle: "",
                  apiFlag: !prev.apiFlag,
                })),
              rowData: isShow.rowData,
              payloadData: payloadData,
            })}
        </CommonModal>
      )}
    </>
  );
};

export default ServerwiseScriptPositionHistory;
